export default [
  {
    path: '/assessNew/personList',
    name: 'personList',
    meta: {
      title: '运营人员考核'
    },
    component: () =>
      import(/* webpackChunkName: "personList" */ '@/views/assessNew/personList.vue')
  },
  {
    path: '/assessNew/personView',
    name: 'personView',
    meta: {
      title: '查看考核详情'
    },
    component: () =>
      import(/* webpackChunkName: "personView" */ '@/views/assessNew/personView.vue')
  },
  {
    path: '/assessNew/streetList',
    name: 'streetList',
    meta: {
      title: '运营街道考核'
    },
    component: () =>
      import(/* webpackChunkName: "streetList" */ '@/views/assessNew/streetList.vue')
  },
  {
    path: '/assessNew/estateList',
    name: 'estateList',
    meta: {
      title: '运营小区考核'
    },
    component: () =>
      import(/* webpackChunkName: "estateList" */ '@/views/assessNew/estateList.vue')
  },
  {
    path: '/assessNew/pointList',
    name: 'pointList',
    meta: {
      title: '运营点位考核'
    },
    component: () =>
      import(/* webpackChunkName: "pointList" */ '@/views/assessNew/pointList.vue')
  }
]
